import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=ed923daa"
import script from "./DashboardEdit.vue?vue&type=script&lang=js"
export * from "./DashboardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports